export default "<p>\r\n  quizviewerstudy works!\r\n</p>\r\n";